import React from 'react'
import GCKCodes from './GCKCodeListPage'

const gckCodeRoutes = [
  {
    breadcrumb: 'GCKCodes',
    path: '',
    element: <GCKCodes />,
    children: [],
  },
]

export default gckCodeRoutes
